import cls from 'classnames';
import { Saturation, Hue } from 'react-color/lib/components/common';
import { useState, useCallback, useEffect } from 'react';
import * as colorHelper from 'react-color/lib/helpers/color';

import { IPickerColor } from '../../../../utils/color/types';
import { Color } from '../../../../utils/color';

import useStyles from './styles';
import { IPickerProps } from './types';
import HuePointer from './HuePointer';
import SaturationPointer from './SaturationPointer';

function Picker({
  color,
  hueClassName,
  hueDirection = 'vertical',
  huePointer,
  hueStyle,
  rootClassName,
  saturationClassName,
  saturationPointer,
  saturationStyle,
  onChange,
  onHueMouseUp,
  onHueTouchEnd,
  onSaturationMouseUp,
  onSaturationTouchEnd,
}: IPickerProps) {
  const classes = useStyles();
  const [colors, setColors] = useState<IPickerColor>(colorHelper.toState(color, 0));
  const handleChange = useCallback(
    (data, event) => {
      const isValidColor = colorHelper.simpleCheckForValidColor(data);

      if (isValidColor) {
        const currentColors = colorHelper.toState(data, data.h || data.oldHue);

        setColors(currentColors);
        onChange(new Color(currentColors.hex), event);
      }
    },
    [onChange],
  );

  useEffect(() => {
    setColors(colorHelper.toState(color, 0));
  }, [color]);

  return (
    <div className={cls(classes.root, rootClassName)}>
      <div
        className={cls(classes.common, classes.saturation, saturationClassName)}
        onMouseUp={onSaturationMouseUp}
        onTouchEnd={onSaturationTouchEnd}
        style={saturationStyle}
      >
        <Saturation
          hsl={colors.hsl}
          hsv={colors.hsv}
          onChange={handleChange}
          pointer={saturationPointer || SaturationPointer}
          styles={saturationStyle}
        />
      </div>
      <div
        className={cls(
          classes.common,
          hueDirection === 'vertical' ? classes.hueVertical : classes.hueHorizontal,
          hueClassName,
        )}
        onMouseUp={onHueMouseUp}
        onTouchEnd={onHueTouchEnd}
        style={saturationStyle}
      >
        <Hue
          hsl={colors.hsl}
          direction={hueDirection}
          onChange={handleChange}
          pointer={huePointer || HuePointer}
          styles={hueStyle}
        />
      </div>
    </div>
  );
}
export default Picker;
